import { render, staticRenderFns } from "./AddTermsAndConditions.vue?vue&type=template&id=4286090d&scoped=true&"
import script from "./AddTermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./AddTermsAndConditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4286090d",
  null
  
)

export default component.exports